<template>
  <vs-popup class=" user-edit-popup"
            id="popup"
            title="STAFF UPDATE"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickUpdateStaffUser)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">First Name</small>
                <vs-input v-model="selectedStaff.name"  name="name" class="w-full required" label=""/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col  md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="email" name="email" rules="required" v-slot="{ errors }">
                <small class="label">Email</small>
                <vs-input  v-model="selectedStaff.email" class="w-full"  name="email" type="email" label="" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <small class="label">Address</small>
              <vs-textarea v-model="selectedStaff.address_1" height="100px"/>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col  md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="dep" name="dep" rules="required" v-slot="{ errors }">
                <small class="label">Department</small>
                <v-select name="dep" multiple label="name" :closeOnSelect="false" v-model="updateStaffSelected" :options="departments" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col  md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="user_group" name="user_group" rules="required" v-slot="{ errors }">
                <small class="label">User Group</small>
                <v-select name="user_group" :closeOnSelect="true" v-model="role"  :options="roles" label="name" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col  md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="contact_1" name="contact_1" rules="required|contactNumber|min_tel|max_tel" v-slot="{ errors }">
                <small class="label">telephone</small>
                <vs-input v-model="selectedStaff.contact_1" class="w-full"  name="contact_1" type="text" label="" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="contact_2" name="contact_2" rules="contactNumber|min_tel|max_tel" v-slot="{ errors }">
                <small class="label">Mobile</small>
                <vs-input v-model="selectedStaff.contact_2" class="w-full"  name="contact_2" type="text" label="" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const StaffRepository = RepositoryFactory.get('staff')
  const DepartmentsRepository = RepositoryFactory.get('departments')
  const RolesRepository = RepositoryFactory.get('roles');
  import vSelect from 'vue-select'

  function initialState() {
    return {
      open: false,
      id: '',
      media: '',
      isImage: '',
      isVideo: '',
      title :'',
      nodata: false,
      isNote:'',
      note:'',
      roles: [],
      role: {},
      selectedStaff: {},
      departments: [],
      updateStaffSelected: []
    }
  }

export default {
  name: 'UpdateStaffPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (id) {
      try {
        await Object.assign(this.$data, initialState())
        this.open = true;
        this.getStaff(id);
        this.loadDepartments();
        this.loadRoles();
      } catch (error) {
      }
    },
    async onClickUpdateStaffUser() {
      const vue = this;
      this.$vs.loading()
      this.selectedStaff.department_ids = this.updateStaffSelected.map((dep) => {
        return dep.id;
      });
      this.selectedStaff.role_id = this.role.id;
      await StaffRepository.updateStaff(this.selectedStaff.id, this.selectedStaff)
      this.$vs.loading.close()
      this.$vs.notify({
        color: 'primary',
        title: 'Updated',
        position:'top-right',
        text: 'Staff update successfully'
      })
      await vue.$parent.refreshData()
      this.open = false;
    },
    async loadDepartments() {
      this.$vs.loading();
      const {data} = await DepartmentsRepository.get(' ', '', '', '' )
      this.departments =  data.data
      this.$vs.loading.close()
    },
    async loadRoles() {
      this.roles = [];
      this.$vs.loading();
      const {data} = await RolesRepository.get(' ', '', '', '' )
      this.roles =  data.data
      this.$vs.loading.close()
    },
    async getStaff(id) {
      this.$vs.loading();
      const { data } = await StaffRepository.getStaff(id)
      this.selectedStaff = data.data
      this.updateStaffSelected = this.selectedStaff.departments
      this.role = this.selectedStaff.role
      this.$vs.loading.close()
    }
  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
  }
}
</script>

<style scoped>
  .video-wrapper {
    width: 100%;
    height: 100%;
  }

  .video-wrapper video {
    object-fit: cover;
    width: 100%;
    height: 100%;

  }
  .image-wrapper {
    width: 100%;
    height: 75%;
  }


</style>
